export const state = () => ({
  company: {},
  customer: { role: 'member' },
});

export const mutations = {
  setCompany(state, company) {
    state.company = company;
  },
  setCustomer(state, customer) {
    state.customer = customer;
  },
};

export const actions = {
  setCompany({ commit }, company) {
    commit('setCompany', company);
  },
  setCustomer({ commit }, customer) {
    commit('setCustomer', customer);
  },
};
